
























import { Component, Vue, Prop } from "vue-property-decorator";
import { getImgUrl } from "../../utils/dummy";
import SwitchLang from "../SwitchLanguageButton.vue";
// import Button from "./Button.vue";

@Component({
  name: "Modal",
  components: {
    SwitchLang,
  },
})
export default class Modal extends Vue {
  @Prop({ default: false }) readonly show: any;
  @Prop({ default: false }) readonly retake: any;
  @Prop({ default: "bn" }) lang: string;
  @Prop({ default: true }) enableLang: boolean;
  @Prop({ default: () => {} }) bodyProps: any;
  @Prop({ default: () => {} }) headerProps: any;

  close() {
    this.$emit("close");
  }

  langChange(e) {
    // this.lang = e;
    this.$emit("lang-change", e);
  }
}
